import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const AccessKeyModal = ({ onClose }) => {
    const { loginWithKey } = useAuth();
    const { t } = useTranslation();
    const [key, setKey] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        let value = e.target.value;
        // NEU: Wir prüfen, ob ein Link eingefügt wurde und extrahieren den Key.
        try {
            if (value.includes('?key=')) {
                const url = new URL(value);
                value = url.searchParams.get('key') || '';
            }
        } catch (error) {
            // Ignoriere ungültige URLs
        }
        setKey(value.trim()); // Entferne Leerzeichen
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!key || loading) return;
        setError('');
        setLoading(true);
        try {
            await loginWithKey(key);
            // Bei Erfolg wird der AuthContext den Nutzer zur MapPage navigieren.
        } catch (err) {
            setError(err.message || 'Invalid or expired key.');
            setLoading(false);
        }
    };

    return (
        <div className="modal-backdrop" onClick={onClose}>
            <motion.div 
                className="modal-content" 
                onClick={e => e.stopPropagation()}
                initial={{ y: 200, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
                <h2 style={{ textAlign: 'center', marginTop: 0 }}>{t('enter_access_key_title')}</h2>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <textarea
                        value={key}
                        onChange={handleInputChange}
                        placeholder={t('paste_key_or_link_placeholder')}
                        rows="4"
                        style={{ fontSize: '1em', resize: 'none' }}
                        required
                    />
                    {error && <p style={{ color: '#ff4d4d', textAlign: 'center', margin: 0 }}>{error}</p>}
                    <button type="submit" disabled={loading} style={{ padding: '15px', borderRadius: '12px', border: 'none', backgroundColor: '#007BFF', color: 'white', fontSize: '1.2em', fontWeight: 'bold' }}>
                        {loading ? t('loading') : t('restore_access_button')}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default AccessKeyModal;
